var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCardMastercard = function SvgCardMastercard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "card-mastercard_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 235 148"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".card-mastercard_svg__cls-2{stroke-width:0;fill:#400000}"))), /*#__PURE__*/React.createElement("rect", {
    width: 235,
    height: 148,
    rx: 16,
    ry: 16,
    style: {
      fill: "#780505",
      strokeWidth: 0
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "card-mastercard_svg__cls-2",
    d: "M40 73.2h-3.8c-1 0-1.8.8-1.8 1.8v6.8c0 1 .8 1.8 1.8 1.8H40c1 0 1.8-.8 1.8-1.8V75c0-1-.8-1.8-1.8-1.8ZM40.1 62.9h-3.8c-1 0-1.8.8-1.8 1.8v5c0 1 .8 1.8 1.8 1.8h3.8c1 0 1.8-.8 1.8-1.8v-5c0-1-.8-1.8-1.8-1.8ZM49.6 74.9h-3.8c-1 0-1.8.8-1.8 1.8v5c0 1 .8 1.8 1.8 1.8h3.8c1 0 1.8-.8 1.8-1.8v-5c0-1-.8-1.8-1.8-1.8ZM49.4 62.9h-3.8c-1 0-1.8.8-1.8 1.8v7.2c0 1 .8 1.8 1.8 1.8h3.8c1 0 1.8-.8 1.8-1.8v-7.2c0-1-.8-1.8-1.8-1.8ZM32.6 81.8V64.4c0-.9-.8-1.6-1.7-1.6h-6.2c-.5 0-1 .2-1.3.6L21.3 66c-.2.3-.4.6-.4 1v12.7c0 .3.1.7.3.9l1.6 2.2c.3.4.8.7 1.4.7h6.7c.9 0 1.7-.8 1.7-1.7Z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 204.6,
    cy: 33.7,
    r: 18.2,
    style: {
      fill: "#f79e1b",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 181.4,
    cy: 33.7,
    r: 18.2,
    style: {
      strokeWidth: 0,
      fill: "#eb001b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193 47.7c4-3.3 6.6-8.4 6.6-14S197 23 193 19.7c-4 3.3-6.6 8.4-6.6 14s2.6 10.7 6.6 14Z",
    style: {
      fill: "#ff5f00",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }));
};
export default SvgCardMastercard;